const prettyUrl = (url: string) => {
  return url.replace("https://", "").replace("http://", "");
};

export default prettyUrl;
